import React, { useState } from 'react';
import { createPortalSession } from '../lib/stripe';
import { Loader2, Settings } from 'lucide-react';

interface StripePortalButtonProps {
  className?: string;
  children: React.ReactNode;
}

export default function StripePortalButton({ 
  className = '', 
  children 
}: StripePortalButtonProps) {
  const [loading, setLoading] = useState(false);

  const handlePortalAccess = async () => {
    setLoading(true);
    try {
      await createPortalSession();
      // No need to set loading to false as we're redirecting to Stripe
    } catch (error) {
      console.error('Portal access error:', error);
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handlePortalAccess}
      disabled={loading}
      className={`${className} ${loading ? 'opacity-75 cursor-not-allowed' : ''}`}
    >
      {loading ? (
        <span className="flex items-center justify-center">
          <Loader2 className="animate-spin h-5 w-5 mr-2" />
          Processing...
        </span>
      ) : (
        <span className="flex items-center justify-center">
          <Settings className="h-5 w-5 mr-2" />
          {children}
        </span>
      )}
    </button>
  );
}